import script from "./CrudPeleador.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudPeleador.vue?vue&type=script&setup=true&lang=js"

import "./CrudPeleador.vue?vue&type=style&index=0&id=742e712e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-742e712e"]])

export default __exports__